import { limitLength } from '@Shared/utils/helpers';
import { Flex, FlexProps, Icon, useColorModeValue } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { FaDotCircle, FaCaretRight } from 'react-icons/fa';

interface NavItemProps extends FlexProps {
  icon?: IconType;
  link?: string;
  level: number;
  name: string;
}

export default function SidebarNavItem({
  link,
  icon,
  color,
  level,
  name,
  ...rest
}: NavItemProps) {
  const pathSnippets = window.location.pathname
  const hcolor = useColorModeValue('black', 'gray.100');
  const navItemColor = useColorModeValue('gray.600', 'gray.300');
  return (
    <>
      {/* <Link style={{ textDecoration: 'none' }} _focus={{ boxShadow: 'none' }}> */}
      <Flex
        fontSize={"sm"}
        align="center"
        px="4"
        py={3}
        pl={(level==1 || level==2) ? 12 : (level==3 || level==4) ? 16 : (level == 5) ? 20 : "16px"}
        mx="4"
        role="group"
        cursor="pointer"
        color={ (link === pathSnippets) ? hcolor : color ? color : navItemColor}
        _hover={{
          color: hcolor,
        }}
        {...rest}
      >
        {icon ? (
          <Icon
            mr="4"
            fontSize="16"
            _groupHover={{
              color: hcolor,
            }}
            as={icon}
          />
        ) : (level === 2) ? 
        <Icon
          mr="2"
          fontSize="6"
          _groupHover={{
            color: hcolor,
          }}
          as={FaDotCircle}
        /> : (level === 4) ? <Icon
              mr="2"
              fontSize="12"
              _groupHover={{
                color: hcolor,
              }}
              as={FaCaretRight}
            /> : ''}
        {limitLength(name, level, 19)}
      </Flex>
      {/* </Link> */}
    </>
  );
}
